import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl} from '@angular/platform-browser';
import { SafeStringType } from '../../clm/types/safe-string-type.enum';

@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {

  constructor(protected sanitiser: DomSanitizer) {
  }

  public transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case SafeStringType.Html:
        return this.sanitiser.bypassSecurityTrustHtml(value);
      case SafeStringType.Style:
        return this.sanitiser.bypassSecurityTrustStyle(value);
      case SafeStringType.Script:
        return this.sanitiser.bypassSecurityTrustScript(value);
      case SafeStringType.Url:
        return this.sanitiser.bypassSecurityTrustUrl(value);
      case SafeStringType.ResourceUrl:
        return this.sanitiser.bypassSecurityTrustResourceUrl(value);
      default:
        throw new Error(`Invalid safe type specified: ${type}`);
    }
  }
}
